import React from 'react';
import { Box, Chip } from '@mui/material';

type RowChipProps = {
    value: string[] | string;
    rowId: number;
    bgColor?: string;
    color?: string;
    // isExpanded: boolean;
    // onToggle: (id: number) => void;
};

const RowChip: React.FC<RowChipProps> = ({ value, rowId, bgColor = '#003771', color = 'white' }) => {
    const commonChipStyles = {
        color: `${color} !important`,
        backgroundColor: `${bgColor} !important`,
        whiteSpace: 'normal',
        overflow: 'visible',
        maxWidth: 'none',
    };

    const renderChips = (sectorsToRender: RowChipProps['value']) => {
			if (typeof sectorsToRender === 'string') {
				return <Chip label={sectorsToRender} variant="filled" sx={commonChipStyles} />;
			}
			if (Array.isArray(sectorsToRender)) {
				return sectorsToRender.map((sector, index) => (
					<Chip key={`row-chip-${sector}-${index}`} label={sector} variant="filled" sx={commonChipStyles} />
				));
			}
		};

    return (
        <Box
            sx={{
                maxWidth: '100%',
                overflowX: 'auto',
                overflowY: 'hidden',
                display: 'flex',  
                gap: 1,
                paddingBottom: '4px',
                '::-webkit-scrollbar': {
                    height: '7px',
                },
            }}
        >
             {renderChips(value)}
        </Box>
    );
};

export default RowChip;